const CURRENCY_FLAGS: Record<string, string> = {
    USD: "/images/US.svg",
    NGN: "/images/NG.svg",
    EUR: "/images/EU.svg",
    GBP: "/images/GB.svg",
    CAD: "/images/CA.svg",
    GHS: "/images/GH.svg",
};

const PRIORITY_PAIRS = ["USD_TO_NGN", "EUR_TO_NGN", "GBP_TO_NGN", "NGN_TO_USD", "USD_TO_GHS", "NGN_TO_GHS"];

function getCurrencyFlag(currency: string): string {
    return CURRENCY_FLAGS[currency] ?? "🌍";
}

function getFeaturedRates(allRates: any) {
    if (!allRates?.rates) return [];

    const ratesArray = Object.entries(allRates.rates).map(([key, value]) => ({
        key,
        ...(value as any),
    }));

    const featured = PRIORITY_PAIRS.map((pair) => ratesArray.find((r) => r.key === pair)).filter(Boolean);

    ratesArray.forEach((rate) => {
        if (!featured.some((f: any) => f.key === rate.key)) {
            featured.push(rate);
        }
    });

    return featured;
}

interface LiveRatesTickerProps {
    allRates: any;
}

export default function LiveRatesTicker({ allRates }: LiveRatesTickerProps) {
    const rates = getFeaturedRates(allRates);

    if (rates.length === 0) return null;

    return (
        <div className="bg-white border-b border-[#E5E7EB] py-3">
            <div className="max-w-7xl mx-auto flex items-center">
                <div className="flex-shrink-0 px-4 border-r border-[#E5E7EB]">
                    <span className="text-sm text-[#637381] font-body font-medium whitespace-nowrap">Live Rates</span>
                </div>
                <div className="overflow-hidden flex-1">
                    <div className="rates-ticker flex items-center">
                        {[...rates, ...rates].map((rate: any, index: number) => {
                            const parts = rate?.key?.split("_") ?? [];
                            const from = parts[0] ?? "";
                            const to = parts[2] ?? "";
                            if (!from || !to || !rate?.rate) return null;

                            return (
                                <div key={`${rate.key}-${index}`} className="flex items-center gap-2 px-6 flex-shrink-0">
                                    <img src={getCurrencyFlag(from)} alt={from} className="w-5 h-5 rounded-full" />
                                    <span className="text-sm text-[#0A0A0A] font-body font-medium whitespace-nowrap">{from}</span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="flex-shrink-0">
                                        <path d="M3 8h10M10 5l3 3-3 3" stroke="#637381" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <img src={getCurrencyFlag(to)} alt={to} className="w-5 h-5 rounded-full" />
                                    <span className="text-sm text-[#0A0A0A] font-body font-medium whitespace-nowrap">{to}</span>
                                    <span className="text-sm text-[#0B7F47] font-body font-semibold whitespace-nowrap">
                                        {parseFloat(rate.rate).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}